$(function () {
    let $top_navbar_collapse = $('#time-dropdown')

    $(window).click(function (e) {
        if ($top_navbar_collapse.hasClass("show")) {
            $top_navbar_collapse.removeClass("show");
            e.preventDefault();
        }
    });

    if ($('html').hasClass('sticky')) {
        $top_navbar_collapse.removeClass("show");
    }

    $top_navbar_collapse.click(function (event) {
        event.stopPropagation();
    });
});